<div class="close-container {{mobile?'wv':'remove-from-desktop'}} ">
  <mat-icon class="close text-sub-heading-color" (click)="onCancel()" aria-hidden="false" role="button" tabindex="0" aria-label="Close" (keydown.enter)="onCancel()" (keydown.space)="$event.preventDefault(); onCancel()">close</mat-icon>
</div>
<div class="container  {{mobile?'container-custom wv':''}} ">
    <div class="header">
      <div></div>
      <div class="title-section  {{mobile?'wv':''}} ">
        <mat-icon class="{{mobile? 'remove-from-mobile': ''}}" aria-hidden="false">tune</mat-icon>
        <p *ngIf="!mobile; else filterColor" class="font-16">Advanced Filter</p>
        <ng-template #filterColor>
          <p class="font-16 font-weight-600 text-heading-color">Advanced Filter</p>
        </ng-template>
      </div>
      <mat-icon class="remove-from-mobile" (click)="onCancel()" aria-hidden="false" role="button" tabindex="0" aria-label="Close" (keydown.enter)="onCancel()" (keydown.space)="$event.preventDefault(); onCancel()">close</mat-icon>
      <!-- <mat-icon *ngIf="!mobile; else closeColor" (click)="onCancel()" aria-hidden="false" role="button" tabindex="0" aria-label="Close" (keydown.enter)="onCancel()" (keydown.space)="$event.preventDefault(); onCancel()">close</mat-icon>
      <ng-template #closeColor>
        <mat-icon class="text-sub-heading-color" (click)="onCancel()" aria-hidden="false" role="button" tabindex="0" aria-label="Close" (keydown.enter)="onCancel()" (keydown.space)="$event.preventDefault(); onCancel()">close</mat-icon>
      </ng-template> -->
    </div>

    <div class="">
      <!-- <div class="col-sm-6">
        <div class="form-group">
          <label>Date Range</label>
          <select class="form-select">
            <option value="" disabled selected>Custom Range</option>
          </select>
        </div>
      </div> -->
      <div class="col-sm-12">
        <label class="date-range-class {{mobile ? 'm10' : ''}}">Date Range</label>
      </div>
      <div class="row justify-content-left align-items-left">
        <div class="col-sm-4">
          <div class="form-group" [formGroup]="dateRangeFormGroup">
            <label></label>
            <!-- <input
              type="text"
              placeholder="03/15/2021"
              title="format: dd/MM/yyyy"
              class="form-control"
            /> -->
            <mat-form-field class="custom-mat-input  {{mobile?'wv':''}} " appearance="outline" style="width: 100%">
              <input class="datepicker-input" readonly formControlName="startDate" matInput [matDatepicker]="picker1" (click)="picker1.open()">
              <mat-datepicker-toggle matSuffix [for]="picker1">
                <mat-icon matDatepickerToggleIcon>{{mobile ? 'date_range' : 'calendar_today'}}</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>

          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group {{mobile?'wv':''}} " [formGroup]="dateRangeFormGroup">
            <mat-form-field class="custom-mat-input" appearance="outline" style="width: 100%">
              <input readonly formControlName="endDate" matInput [matDatepicker]="picker2" (click)="picker2.open()">
              <mat-datepicker-toggle matSuffix [for]="picker2">
                <mat-icon matDatepickerToggleIcon>{{mobile ? 'date_range' : 'calendar_today'}}</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>

          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center align-items-center" [formGroup]="transactionTypeFormGroup">
      <div class="title-filter-option">
        <div class="form-group {{mobile?'wv':''}} ">
          <label>Transaction Type</label>
        </div>
      </div>

      <div class="col-sm-3 {{mobile?'wv':''}} ">
        <div class="check">
          <mat-checkbox [(ngModel)]="isInvoiceChecked" class="checkbox" formControlName="Invoice">Invoice</mat-checkbox>
        </div>
      </div>
      <div class="col-sm-3 {{mobile?'wv':''}} ">
        <div class="check">
          <mat-checkbox class="checkbox" [(ngModel)]="isPaymentChecked" formControlName="Payment">Payment</mat-checkbox>
        </div>
      </div>
      <div class="col-sm-3 {{mobile?'wv':''}} ">
        <div class="check">
          <mat-checkbox class="checkbox" [(ngModel)]="isCreditChecked" formControlName="Credit">Credit</mat-checkbox>
        </div>
      </div>
      <div class="col-sm-3 {{mobile?'wv remove-from-mobile':''}} ">
        <div class="check">
          <mat-checkbox class="checkbox" [(ngModel)]="isRefundChecked" formControlName="Refund">Refund</mat-checkbox>
        </div>
      </div>
    </div>

    <div class="action-btn-container flex justify-content-center">
      <button *ngIf="!mobile; else btnStyle" mat-flat-button class="edit-form-button standard-btn primar-btn btn-width" (click)="onApply()">
        Apply Filter
      </button>
      <ng-template #btnStyle>
        <button mat-flat-button class="dialog-btn standard-btn button-with-radius btn-width" (click)="onApply()">
          Apply Filter
        </button>
      </ng-template>
    </div>
  </div>
